import { Ansprechpartner } from 'api/ansprechpartner';
import { Zusatzadresse } from 'api/zusatzadresse';
import { Kunde } from 'api/kunde';
import { Auftrag } from 'api/auftrag';
import { Maschinenkunde } from 'api/maschinenkunde';
import { Bestellung } from 'api/bestellung';
import { ViewType } from './formatter';
import { getInstanceConfig } from './helper';

export const TerminArtLabel: { [key: string]: string } = {
    A: 'Anruf',
    // I: 'Infomaterial',
    T: 'Termin',
    U: 'Urlaub',
    B: 'Bitte bearbeiten',
    Z: 'Zu erledigen',
    // W: 'Wiedervorlage',
    N: 'Angebot Nachfassen',
    W: 'Auftragswiedervorlage',
    M: 'Maschinenaufstellung/auflieferung',
    S: 'Service & Reparatur',
    O: 'Servicetour',
    H: 'Technische Hilfeleistung telefonisch',
    V: 'Wartungsvertrag',
};

export const AnredeLabel: { [key: string]: string } = {
    H: 'Herr',
    F: 'Frau',
    FA: 'Familie',
    FI: 'Firma',
};

export const KundeArtLabel: { [key: string]: string } = {
    I: 'Interessent',
    K: 'Kunde',
    KL: 'Kunde/Lieferant',
    L: 'Lieferant',
    S: 'Sonstiges',
    M: 'Muster',
};

if (getInstanceConfig().instance === 'easyloop') {
    KundeArtLabel.GM = 'GM';
}

export const KundeKategorieLabel: { [key: string]: string } = {
    '0': '0',
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
    E: 'E',
    X: 'X',
};

export const SpracheLabel: { [key: string]: string } = {
    D: 'Deutsch',
    E: 'Englisch',
    I: 'Italienisch',
};

export const ZusatzadresseTypLabel: { [key: string]: string } = {
    L: 'Lieferadresse',
    R: 'Rechnungsadresse',
};

export function getAnsprechpartnerLabel(ansprechpartner?: Ansprechpartner): string {
    if (!ansprechpartner) {
        return '';
    }

    return (
        (ansprechpartner.anrede === 'H' ? 'Herr ' : '') +
        (ansprechpartner.anrede === 'F' ? 'Frau ' : '') +
        (ansprechpartner.titel ? ansprechpartner.titel + ' ' : '') +
        ansprechpartner.name
    );
}

export function getMaschinenkundeLabel(maschinenkunde?: Maschinenkunde): string {
    if (!maschinenkunde) {
        return '';
    }

    return (
        (maschinenkunde.hersteller ? maschinenkunde.hersteller + ', ' : '') +
        (maschinenkunde.type ? maschinenkunde.type + ', ' : ' ') +
        (maschinenkunde.baujahr ? ' (' + maschinenkunde.baujahr + ') ' : '')
    );
}

export function getAuftragLabel(auftrag?: Auftrag | null, kunde?: Kunde | null): string {
    if (!auftrag) {
        return '';
    }

    let label = `Auftrag ${auftrag.nr}`;

    if (auftrag.rahmen) {
        label = `Rahmenauftrag ${auftrag.nr} `;
    } else if (auftrag.abrufZu?.trim()) {
        label = `Abrufauftrag ${auftrag.nr}  (zu ${auftrag.abrufZu}) `;
    }

    return `${label} - ${kunde?.name1 || ''} ${kunde?.name2 || ''} ${kunde?.nr ? '(' + kunde?.nr + ')' : ''}`;
}

export function getBestellungLabel(bestellung?: Bestellung | null, kunde?: Kunde | null): string {
    if (!bestellung) {
        return '';
    }

    let label = `Bestellung ${bestellung.nr}`;

    if (bestellung.rahmen) {
        label = `Rahmenbestellung ${bestellung.nr} `;
    } else if (bestellung.abrufZu?.trim()) {
        label = `Abrufbestellung ${bestellung.nr}  (zu ${bestellung.abrufZu}) `;
    }

    return `${label} - ${kunde?.name1 || ''} ${kunde?.name2 || ''} ${kunde?.nr ? '(' + kunde?.nr + ')' : ''}`;
}

export function getZusatzadresseLabel(zusatzadresse?: Zusatzadresse): string {
    if (!zusatzadresse) {
        return '';
    }

    return (
        zusatzadresse.name1 +
        (zusatzadresse.name2 ? ' ' : '') +
        zusatzadresse.name2 +
        ' ( ' +
        zusatzadresse.plz +
        ' ' +
        zusatzadresse.ort +
        ', ' +
        zusatzadresse.strasse +
        ', ' +
        zusatzadresse.land +
        ')'
    );

    /*
    return (
        (zusatzadresse?.typ ? ZusatzadresseTypLabel[zusatzadresse?.typ] : '') +
        ' - ' +
        zusatzadresse?.name1 +
        ' ' +
        zusatzadresse?.name2
    );
     */
}

export const AngebotStatusLabel: { [key: string]: string } = {
    0: 'in Arbeit',
    1: 'versendet',
    2: 'angenommen',
    3: 'abgelehnt',
};

export const ServiceStatusLabel: { [key: string]: string } = {
    0: 'in Arbeit',
    1: 'unterschrieben',
    2: 'versendet',
    3: 'Auftrag erstellt',
};

export const ServiceTypLabel: { [key: string]: string } = {
    1: 'Service',
    2: 'Aufstellung',
    3: 'Reparatur',
};

export const AuftragStatusLabel: { [key: string]: string } = {
    0: 'in Arbeit',
    1: 'AB versendet',
    // 2: 'Status 2', // obsolete
    9: 'Teillieferung',
    // 10: 'geliefert',
    4: 'abgeschlossen',
    // 7: 'in Bestellung', // obsolete
    // 13: 'gedruckt', // obsolete
};

export const BestellungStatusLabel: { [key: string]: string } = {
    0: 'in Arbeit',
    1: 'versendet',
    8: 'Teillieferung',
    4: 'abgeschlossen',
    // 10: 'Offen', // obsolete
};

export const LieferungStatusLabel: { [key: string]: string } = {
    0: 'in Arbeit',
    1: 'LS versendet',
    // 2: 'Status 2', // obsolete
    4: 'abgeschlossen',
    // 7: 'in Bestellung', // obsolete
    // 9: 'Teillief./Best.', // obsolete
    // 13: 'gedruckt', // obsolete
};

export const RechnungStatusLabel: { [key: string]: string } = {
    0: 'in Arbeit',
    1: 'versendet',
    5: 'in Buchh.',
    6: 'bezahlt',
};

export const LieferantenrechnungStatusLabel: { [key: string]: string } = {
    0: 'in Arbeit',
};

export const LieferArtLabel: { [key: string]: string } = {
    D: 'Direkt',
    L: 'Lager',
    R: 'Reserviert',
    X: 'Res. für Rahmen',
};

export const SmRefTypeLabel: { [key: string]: string } = {
    angebot: 'Angebot',
    service: 'Service',
    auftrag: 'Auftrag',
    bestellung: 'Bestellung',
    lieferung: 'Lieferung',
    rechnung: 'Rechnung',
    lieferantenrechnung: 'Lieferantenrechnung',
};

export const SmRefTypeView: { [key: string]: ViewType } = {
    angebot: 'angebote',
    service: 'services',
    auftrag: 'auftraege',
    bestellung: 'bestellungen',
    lieferung: 'lieferungen',
    rechnung: 'rechnungen',
};

export const AttachmentArtLabel: { [key: string]: string } = {
    1: 'Angebot',
    2: 'Ang.-Kalk',
    3: 'Sonstiges',
    4: 'Vertrag',
    5: 'SFA/Folienanalyse',
    6: 'Service',
};

export const BhCodeLabel: { [key: string]: string } = {
    H: 'Handel',
    A: 'ARA',
    S: 'Schadensfälle',
    D: 'Dienstleistung',
    F: 'Frachten',
    V: 'Anlagenverkauf',
};

export const BhLandLabel: { [key: string]: string } = {
    I: 'Inland',
    E: 'EU',
    A: 'EU-Ausland',
};

export const RecordTypeLabel: { [key: string]: string } = {
    angebot: 'Angebot',
    service: 'Service',
    auftrag: 'Auftrag',
    bestellung: 'Bestellung',
    lieferung: 'Lieferung',
    rechnung: 'Rechnung',
};

export const RecordTypeShortLabel: { [key: string]: string } = {
    angebot: 'An',
    service: 'Se',
    auftrag: 'Au',
    bestellung: 'Be',
    lieferung: 'Li',
    rechnung: 'Re',
};

export const HistoryActionLabel: { [key: string]: string } = {
    add: 'Neue Position',
    change: 'Menge/LArt geändert',
    delete: 'Position gelöscht',
    correct: 'Korrektur',
};

export const HistoryActionShortLabel: { [key: string]: string } = {
    add: 'Pos. angelegt',
    change: 'Pos. geändert',
    delete: 'Pos. gelöscht',
    correct: 'Korrektur',
    finalize: 'Abgeschlossen',
};

export const RolleLabel: { [key: string]: string } = {
    GF: 'Geschäftsführung',
    ID: 'Innendienst',
    AD: 'Außendienst',
    EX: 'Extern',
};

export const BetreuerWorkDayAbsentLabel: { [key: string]: string } = {
    public_holiday: 'Feiertag',
    free: 'Frei',
    sick: 'Krank',
    holiday: 'Urlaub',
    other: 'Sonstiges',
};

export const AblehnGrundLabel: { [key: string]: string } = {
    0: ' ',
    1: 'zu teuer',
    2: 'kein Bedarf',
    3: 'Gültig bis überschritten',
    4: 'zur Zeit nicht',
};
